const communityCollectedSolFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
  useGrouping: false
});

export function formatSolAmount(value) {
  const amount = Number(value || 0);
  return (Number.isFinite(amount) ? amount : 0).toFixed(2);
}

export function formatSolTotalVotes(value) {
  return `${formatSolAmount(value)} SOL total votes`;
}

export function formatCommunityCollectedSolAmount(value) {
  const amount = Number(value || 0);
  return communityCollectedSolFormatter.format(Number.isFinite(amount) ? amount : 0);
}

export function formatCommunityCollectedSol(value) {
  return `${formatCommunityCollectedSolAmount(value)} SOL collected`;
}
